import { render, staticRenderFns } from "./AnnualReview.vue?vue&type=template&id=5c4a1075&scoped=true&"
import script from "./AnnualReview.vue?vue&type=script&lang=js&"
export * from "./AnnualReview.vue?vue&type=script&lang=js&"
import style0 from "./AnnualReview.vue?vue&type=style&index=0&id=5c4a1075&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4a1075",
  null
  
)

export default component.exports